/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { withFormik } from 'formik'
const Yup = require('yup')

/**
 *     Import
 *     - Components
 */
import { Button } from '../../../common/Button/Button'
import TableContent from './components/TableContent'
import { Alert } from '../../../common/Alert/Alert'
import ToolTip from '../../../common/ToolTip/ToolTip'
import InputRange from '../../../common/RangeInput/RangeInput'
import { currency, symbol } from '../../../common/CurrencyFormat'

/**
 *     Import
 *     - CSS
 */
import '../styles/Step03.css'

/**
 * Step03 class {/quote/:id/step03}
 *
 * @class Step03FormHTML
 * @extends {React.Component<any, any>}
 */
class Step03FormHTML extends React.Component<any, any> {

    /**
     * Creates an instance of Step03FormHTML.
     *
     * @param {*} props
     * @memberof Step03FormHTML
     */
    constructor(props: any) {
        super(props)

        this.state = {
            priceBasis: this.props.editQuote ? this.props.data.priceBasis : 'selling price',
            settlementBasis: this.props.editQuote ? this.props.data.settlementBasis : 0.9,
            inputValue: this.props.editQuote ? this._getInputValue(this.props.data.settlementBasis) : 3,
            tableItems: [
                {
                    type: 'picturesPainingsPrints',
                    text: 'Pictures / Paintings / Prints',
                    valueStock: this.props.editQuote ? this.props.data.pricePicturesPainingsPrints : 0,
                    valueInsured: this.props.editQuote ? this.props.data.sumPicturesPainingsPrints : 0,
                },
                {
                    type: 'antiquesFurniture',
                    text: 'Antiques, Furniture',
                    valueStock: this.props.editQuote ? this.props.data.priceAntiquesFurniture : 0,
                    valueInsured: this.props.editQuote ? this.props.data.sumAntiquesFurniture : 0,
                },
                {
                    type: 'bronzesSculpturesMarbles',
                    text: 'Bronzes / Sculptures / Marbles',
                    valueStock: this.props.editQuote ? this.props.data.priceBronzesSculpturesMarbles : 0,
                    valueInsured: this.props.editQuote ? this.props.data.sumBronzesSculpturesMarbles : 0,
                },
                {
                    type: 'silverObjectDArt',
                    text: 'Silver & Objets D\'art',
                    valueStock: this.props.editQuote ? this.props.data.priceSilverObjectDArt : 0,
                    valueInsured: this.props.editQuote ? this.props.data.sumSilverObjectDArt : 0,
                },
                {
                    type: 'porcelainBrittleItems',
                    text: 'Porcelain / Brittle Items',
                    valueStock: this.props.editQuote ? this.props.data.pricePorcelainBrittleItems : 0,
                    valueInsured: this.props.editQuote ? this.props.data.sumPorcelainBrittleItems : 0,
                },
                {
                    type: 'carpetsRugsTapestriesTextiles',
                    text: 'Carpets / Rugs / Tapestries / Textiles',
                    valueStock: this.props.editQuote ? this.props.data.priceCarpetsRugsTapestriesTextiles : 0,
                    valueInsured: this.props.editQuote ? this.props.data.sumCarpetsRugsTapestriesTextiles : 0,
                },
                {
                    type: 'clocks',
                    text: 'Clocks',
                    valueStock: this.props.editQuote ? this.props.data.priceClocks : 0,
                    valueInsured: this.props.editQuote ? this.props.data.sumClocks : 0,
                },
                {
                    type: 'antiqueJewellery',
                    text: 'Antique Jewellery',
                    valueStock: this.props.editQuote ? this.props.data.priceAntiqueJewellery : 0,
                    valueInsured: this.props.editQuote ? this.props.data.sumAntiqueJewellery : 0,
                },
                {
                    type: 'collectiblesMemorabilia',
                    text: 'Collectibles and Memorabilia',
                    valueStock: this.props.editQuote ? this.props.data.priceCollectiblesMemorabilia : 0,
                    valueInsured: this.props.editQuote ? this.props.data.sumCollectiblesMemorabilia : 0,
                },
            ],
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    /**
     * Reset all quote data before going to next step
     *
     * @memberof Step03FormHTML
     */
    componentWillUnmount() {
        if (this.props.resetQuotes) {
            this.props.resetQuotes()
        }
    }

    /**
     *  Depending on the settlement basis value
     * return the index for the range slider
     */
    _getInputValue = (settlementBasis: any) => {
        switch (settlementBasis) {
            case 0.5: return 0
            case 0.7: return 1
            case 0.8: return 2
            case 0.9: return 3
            case 1: return 0
            case 1.2: return 1
            case 1.3: return 2
            case 1.5: return 3

            default: return 0
        }

    }

    /**
     * Update the component state when changing the
     * range of the input. It will also update the Formik
     * values for the form validation
     *
     * @param {*} inputValue the new value in the input range
     * @param {*} priceBasis priceBasis if is 'selling' or 'cost'
     * @memberof Step03FormHTML
     */
    _updateSettlementBasis = (inputValue, priceBasis) => {
        let negativePercentages = [0.5, 0.7, 0.8, 0.9]
        let positivePercentages = [1, 1.2, 1.3, 1.5]

        let newState = this.state

        /**
         * Switch between priceBasis {positives or negative values}:
         * - Calculates the new state to update avoiding void data inputs
         * - Updates the Formik values for the validation
         * - Updates the state
         */
        switch (priceBasis) {
            case 'selling price':
                newState.tableItems.map((item, index) => {
                    if (item.valueStock !== '') {
                        newState.tableItems[index].valueInsured =
                            (parseFloat(item.valueStock) * negativePercentages[inputValue]).toFixed(2)
                    } else {
                        newState.tableItems[index].valueInsured =
                            (Number(0) * negativePercentages[inputValue]).toFixed(2)
                    }
                })
                this._updatePropsValues(newState.tableItems, 'selling price', negativePercentages[inputValue])
                this.setState(
                    {
                        tableItems: newState.tableItems,
                        settlementBasis: negativePercentages[inputValue],
                        inputValue: inputValue,
                    }
                )
                break

            case 'cost price':
                newState.tableItems.map((item, index) => {
                    if (item.valueStock !== '') {
                        newState.tableItems[index].valueInsured =
                            (parseFloat(item.valueStock) * positivePercentages[inputValue]).toFixed(2)
                    } else {
                        newState.tableItems[index].valueInsured =
                            (Number(0) * positivePercentages[inputValue]).toFixed(2)
                    }
                })
                this._updatePropsValues(newState.tableItems, 'cost price', positivePercentages[inputValue])
                this.setState(
                    {
                        tableItems: newState.tableItems,
                        settlementBasis: positivePercentages[inputValue],
                        inputValue: inputValue,
                    }
                )
                break

            default:
                break
        }

    }

    /**
     * Update the values for Formik and the state when
     * changing data in the child component {TableContent}
     *
     * @param {*} tableItems the new tableItems to update with
     * @memberof Step03FormHTML
     */
    _updateParentStateItems = (tableItems: any) => {
        this._updatePropsValues(tableItems, this.state.priceBasis, this.state.settlementBasis)
        this.setState({ tableItems })
    }

    /**
     * Method for updating all the values in Formik
     * for the form validation when it changes in the
     * child component TableContent
     *
     * @param {*} data the new tableItems to update from TableContent
     * @param {String} priceBasis the new priceBasis
     * @param {Number} settlementBasis the new settlementBasis
     * @memberof Step03FormHTML
     */
    _updatePropsValues = (data: any, priceBasis: String, settlementBasis: Number) => {
        let props = this.props
        data.map((item, index) => {
            props.values['sum' +
                (item.type).charAt(0).toUpperCase() + (item.type).slice(1)] = parseFloat(item.valueInsured).toFixed(2)
            props.values['price' +
                (item.type).charAt(0).toUpperCase() + (item.type).slice(1)] = parseFloat(item.valueStock).toFixed(2)
            props.setFieldTouched(
                `sum${(item.type).charAt(0).toUpperCase()}${(item.type).slice(1)}`,
                parseFloat(item.valueInsured).toFixed(2))
        })
        props.values.priceBasis = priceBasis
        props.values.settlementBasis = settlementBasis

    }

    /**
     * Calculates the result of the
     * Total sales/costs and Sum insured columns
     *
     * @param {String} type type of the column to calculate: insured or stock
     * @memberof Step03FormHTML
     */
    _calculateSum = (type) => {
        let total = 0

        this.state.tableItems.map((item) => {
            if (type === 'insured') {
                total += parseFloat(item.valueInsured)
            } else if (type === 'stock') {
                total += item.valueStock ? Number(item.valueStock) : Number(0)
            }
        })

        this.props.values.totalSumInsured = Number(total).toFixed(2)
        // return Number(total).toFixed(2)
        return Number(total)
    }

    /**
     * Update priceBasis in the state and Formik values
     *
     * @param {String} priceBasis the new priceBasis to update
     * @memberof Step03FormHTML
     */
    _changePriceBasis = (priceBasis: String) => {
        this.setState({ priceBasis })
        this._updateSettlementBasis(this.state.inputValue, priceBasis)
    }

    render() {

        const {
            handleSubmit,
            quote,
        } = this.props

        let errorList: any[] = []

        let errorState: any = null // Fake errorState for test proposes
        if (errorState !== null) { errorList.push(errorState._data) }

        let tableItems = this.state.tableItems

        /**
         * Check if at least one item have been filled
         */
        let atLeastOneItem = (
            this._calculateSum('insured') !== 0
        ) ? false : true

        if (quote.step03.done && !this.props.editQuote) {
            this.props.history.push('/quote/' + this.props.match.params.id + '/step04')
        }

        if (this.props.updateDirty) {
            // console.log(this.props.dirty)
            this.props.dirty ? this.props.updateDirty(true) : this.props.updateDirty(false)
        }

        return (
            <div className="step03">
                {(!!Object.keys(this.props.errors).length && !!Object.keys(this.props.touched).length) && (
                    Object.keys(this.props.errors).filter(
                        (msg) => Object.keys(this.props.touched).includes(msg)
                    ).map((error, idx) => {
                        const msg = this.props.errors[error]
                        errorList.push(`${msg.charAt(0).toUpperCase()}${msg.slice(1)}`)
                    })
                )}

                {(errorList.length) ? (
                    <Alert type="error">
                        {errorList.map((a, i) => (<p key={i}>{a}</p>))}
                    </Alert>
                ) : null}

                {(quote.step03.error) ? (
                    <Alert type="error">
                        Error: something went wrong please contact support
                    </Alert>
                ) : null}

                <form className="step03Form" onSubmit={handleSubmit}>
                    <div>
                        <div className="inline__group">
                            <div className="inline__items shadow">
                                <div className="inline__item title">Stock sum insured</div>
                                <div className="inline__icon">
                                    <ToolTip position="left">
                                        Art & Antique dealers record stock they own based on either total cost or total
                                        selling price.  They then usually apply an uplift or a reduction to define their
                                         expected retail price and hence sum insured.  Begin by selecting cost price or
                                         selling price depending on how the client records stock. Next enter the total
                                         values before using the settlement basis slider to achieve a total sum insured
                                         in line with your client’s business practice (this is the figure that will
                                         appear on the schedule and will be the maximum the insured can claim).
                                </ToolTip>
                                </div>
                                <div className="inline__item">
                                    Please begin by selecting selling price or cost price
                            </div>
                            </div>
                        </div>
                        <div className="inline__group">
                            <div className={`inline__buttons center ${(this.props.mta ? '' : '')}`}>
                                <div
                                    className={'inline__item button__switch ' +
                                        (this.state.priceBasis === 'selling price' ?
                                            'selected' :
                                            '')}
                                    onClick={() => { this._changePriceBasis('selling price') }}
                                >
                                    Selling price
                                </div>
                                <div
                                    className={'inline__item button__switch ' +
                                        (this.state.priceBasis === 'cost price' ?
                                            'selected' :
                                            '')}
                                    onClick={() => { this._changePriceBasis('cost price') }}
                                >Cost price
                                </div>
                            </div>
                        </div>
                        <div className="table__titles shadow">
                            <div className="table__50-item">
                                Type of insured item
                        </div>
                            <div className="table__30-item">
                                {(this.state.priceBasis === 'cost price' ?
                                    'Cost' :
                                    'Selling')} price value of stock
                        </div>
                            <div className="table__20-item">
                                Sum insured
                        </div>
                        </div>
                        <TableContent
                            tableItems={tableItems}
                            settlementBasis={this.state.settlementBasis}
                            updateParentStateItems={this._updateParentStateItems}

                        />
                        <div
                            className={`values__group val_cust 
                        ${(this._calculateSum('stock') > 1000) ? 'cust' : ''}`}
                        >
                            <div
                                className={`values__item values__item--left
                            ${(this._calculateSum('stock') > 1000) ? 'width_set_left' : ''} `}
                            >
                                <div className="values__item--left__text">
                                    <div className="values__item--left__text__inline">
                                        Select settlement basis
                                </div>
                                    <div className="values__item--left__text__icon">
                                        <ToolTip position="left" verticalPosition="top">
                                            The settlement basis slider calculates the final stock sum insured that will
                                            appear on the quote schedule.
                                        {(this.state.priceBasis !== 'selling price') ?
                                                ' Cost price: The cost at which the stock was purchased by ' +
                                                'the policy holder.' :
                                                ' Selling Price: The retail, list or full selling price of ' +
                                                'the stock prior to any discounts'}
                                        </ToolTip>
                                    </div>
                                </div>
                                <div>
                                    <div className="measurements measurements-1" />
                                    <div className="measurements measurements-2" />
                                    <div className="measurements measurements-3" />
                                    <div className="measurements measurements-4" />

                                    <InputRange
                                        onChange={
                                            (value) => {
                                                this._updateSettlementBasis(value, this.state.priceBasis)
                                            }}
                                        value={this.state.inputValue}
                                        max={3}
                                    />

                                    <div
                                        className={`percentages percentages-1
                                            ${(this.state.inputValue === 0) ? 'active' : ''}`}
                                    >{
                                            (this.state.priceBasis === 'cost price') ? 'Cost price' : '-50%'
                                        }
                                    </div>
                                    <div
                                        className={`percentages percentages-2
                                    ${(this.state.inputValue === 1) ? 'active' : ''}`}
                                    >{
                                            (this.state.priceBasis === 'cost price') ? '+20%' : '-30%'
                                        }
                                    </div>
                                    <div
                                        className={`percentages percentages-3
                                    ${(this.state.inputValue === 2) ? 'active' : ''}`}
                                    >{
                                            (this.state.priceBasis === 'cost price') ? '+30%' : '-20%'
                                        }
                                    </div>
                                    <div
                                        className={`percentages percentages-4
                                    ${(this.state.inputValue === 3) ? 'active' : ''}`}
                                    >{
                                            (this.state.priceBasis === 'cost price') ? '+50%' : '-10%'
                                        }
                                    </div>
                                </div>

                            </div>
                            <div
                                className={`values__item values__item--right 
                                ${(this._calculateSum('stock') > 1000) ? 'width_set_right' : ''}`}
                            >
                                <div>
                                    Total {(this.state.priceBasis === 'cost price' ? 'cost' : 'sales')} value
                                    <h3 className="col_value">{currency(this._calculateSum('stock'))}</h3>
                                </div>
                                <div>
                                    Sum insured value
                                    <h3 className="col_value">{currency(this._calculateSum('insured'))}</h3>
                                </div>
                            </div>
                        </div>

                        {this.props.editQuote && this.props.dirty ? (
                            <div className="quote__form__group quote__form__group--update">
                                <Button
                                    type="submit"
                                >
                                    Update
                                </Button>
                            </div>
                        ) : null}

                        <div className="quote__form__group quote__form__group--submit">
                            <Button
                                type="submit"
                                onClick={() => window.scrollTo(0, 0)}
                                disabled={atLeastOneItem}
                            >
                                Save and continue
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

/**
 *     Formik Validation Struture
 */
const Step03Form = withFormik<any, any>({

    mapPropsToValues: (props: any) => ({
        priceBasis: 'selling price',
        settlementBasis: Number(1),
        sumAntiqueJewellery: Number(0),
        sumAntiquesFurniture: Number(0),
        sumBronzesSculpturesMarbles: Number(0),
        sumCarpetsRugsTapestriesTextiles: Number(0),
        sumClocks: Number(0),
        sumCollectiblesMemorabilia: Number(0),
        sumPicturesPainingsPrints: Number(0),
        sumPorcelainBrittleItems: Number(0),
        sumSilverObjectDArt: Number(0),
        priceAntiqueJewellery: Number(0),
        priceAntiquesFurniture: Number(0),
        priceBronzesSculpturesMarbles: Number(0),
        priceCarpetsRugsTapestriesTextiles: Number(0),
        priceClocks: Number(0),
        priceCollectiblesMemorabilia: Number(0),
        pricePicturesPainingsPrints: Number(0),
        pricePorcelainBrittleItems: Number(0),
        priceSilverObjectDArt: Number(0),
        totalSumInsured: Number(0),
    }),

    validationSchema: Yup.object().shape({
        priceBasis: Yup.string().required('Price basis is not setted'),
        settlementBasis: Yup.string().required('Settlement basis is not setted'),
        sumAntiqueJewellery: Yup.number()
            .min(0, 'Antique Jewellery sum insurred can\'t be lower than 0')
            .required('Antique Jewellery is required'),
        sumAntiquesFurniture: Yup.number()
            .min(0, 'Antiques, Furniture sum insurred can\'t be lower than 0')
            .required('Antiques, Furniture is required'),
        sumBronzesSculpturesMarbles: Yup.number()
            .min(0, 'Bronzes / Sculptures / Marbles sum insurred can\'t be lower than 0')
            .required('Bronzes / Sculptures / Marbles is required'),
        sumCarpetsRugsTapestriesTextiles: Yup.number()
            .min(0, 'Carpets / Rugs / Tapestries / Textiles sum insurred can\'t be lower than 0')
            .required('Carpets / Rugs / Tapestries / Textiles is required'),
        sumClocks: Yup.number()
            .min(0, 'Clocks sum insurred can\'t be lower than 0')
            .required('Clocks is required'),
        sumCollectiblesMemorabilia: Yup.number()
            .min(0, 'Collectibles and Memorabilia sum insurred can\'t be lower than 0')
            .required('Collectibles and Memorabilia is required'),
        sumPicturesPainingsPrints: Yup.number()
            .min(0, 'Pictures / Paintings / Prints sum insurred can\'t be lower than 0')
            .required('Pictures / Paintings / Prints is required'),
        sumPorcelainBrittleItems: Yup.number()
            .min(0, 'Porcelain / Brittle Items sum insurred can\'t be lower than 0')
            .required('Porcelain / Brittle Items is required'),
        sumSilverObjectDArt: Yup.number()
            .min(0, 'Silver & Objets D\'art sum insurred can\'t be lower than 0')
            .required('Silver & Objets D\'art is required'),
        priceAntiqueJewellery: Yup.number()
            .min(0, 'Antique Jewellery price insurred can\'t be lower than 0')
            .max(20000, `Antique Jewellery price insurred can\'t be higher than ${symbol()} 20.000`)
            .required('Antique Jewellery is required'),
        priceAntiquesFurniture: Yup.number()
            .min(0, 'Antiques, Furniture price insurred can\'t be lower than 0')
            .required('Antiques, Furniture is required'),
        priceBronzesSculpturesMarbles: Yup.number()
            .min(0, 'Bronzes / Sculptures / Marbles price insurred can\'t be lower than 0')
            .required('Bronzes / Sculptures / Marbles is required'),
        priceCarpetsRugsTapestriesTextiles: Yup.number()
            .min(0, 'Carpets / Rugs / Tapestries / Textiles price insurred can\'t be lower than 0')
            .required('Carpets / Rugs / Tapestries / Textiles is required'),
        priceClocks: Yup.number()
            .min(0, 'Clocks price insurred can\'t be lower than 0')
            .required('Clocks is required'),
        priceCollectiblesMemorabilia: Yup.number()
            .min(0, 'Collectibles and Memorabilia price insurred can\'t be lower than 0')
            .required('Collectibles and Memorabilia is required'),
        pricePicturesPainingsPrints: Yup.number()
            .min(0, 'Pictures / Paintings / Prints price insurred can\'t be lower than 0')
            .required('Pictures / Paintings / Prints is required'),
        pricePorcelainBrittleItems: Yup.number()
            .min(0, 'Porcelain / Brittle Items price insurred can\'t be lower than 0')
            .required('Porcelain / Brittle Items is required'),
        priceSilverObjectDArt: Yup.number()
            .min(0, 'Silver & Objets D\'art price insurred can\'t be lower than 0')
            .required('Silver & Objets D\'art is required'),
        totalSumInsured: Yup.number()
            .min(1000, `The sum insured value can\'t be less than ${symbol()} 1000`),
    }),

    handleSubmit: (values, { props, setSubmitting, resetForm }) => {
        let content = {
            'quote': {
                'id': props.editRenewal ? props.renewalQuoteId : props.match.params.id,
                'stockBusinessAssets': {
                    'priceBasis': values.priceBasis,
                    'settlementBasis': values.settlementBasis,
                    'sumPicturesPainingsPrints': values.sumPicturesPainingsPrints,
                    'sumAntiquesFurniture': values.sumAntiquesFurniture,
                    'sumBronzesSculpturesMarbles': values.sumBronzesSculpturesMarbles,
                    'sumSilverObjectDArt': values.sumSilverObjectDArt,
                    'sumPorcelainBrittleItems': values.sumPorcelainBrittleItems,
                    'sumCarpetsRugsTapestriesTextiles': values.sumCarpetsRugsTapestriesTextiles,
                    'sumClocks': values.sumClocks,
                    'sumAntiqueJewellery': values.sumAntiqueJewellery,
                    'sumCollectiblesMemorabilia': values.sumCollectiblesMemorabilia,
                    'pricePicturesPainingsPrints': values.pricePicturesPainingsPrints,
                    'priceAntiquesFurniture': values.priceAntiquesFurniture,
                    'priceBronzesSculpturesMarbles': values.priceBronzesSculpturesMarbles,
                    'priceSilverObjectDArt': values.priceSilverObjectDArt,
                    'pricePorcelainBrittleItems': values.pricePorcelainBrittleItems,
                    'priceCarpetsRugsTapestriesTextiles': values.priceCarpetsRugsTapestriesTextiles,
                    'priceClocks': values.priceClocks,
                    'priceAntiqueJewellery': values.priceAntiqueJewellery,
                    'priceCollectiblesMemorabilia': values.priceCollectiblesMemorabilia,
                },
            },
        }

        if (props.mta) {
            props.updateData(content)
        } else {
            if (props.editRenewal) {
                props.setStep03Renewals(content).finally(() => {
                    props.getRenewalVariation(props.renewalQuoteId)
                })
            } else {
                props.setStep03(content)
                props.getQuoteVariation(props.match.params.id)
            }
        }
        resetForm(content)

        if (props.editQuote) {
            setTimeout(props.update, 500)
        }
    },

})(Step03FormHTML)

export default Step03Form



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step03/Step03.tsx